import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _slicedToArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { createDecorator } from '../../instantiation/common/instantiation.js';
import { toDisposable, Disposable } from '../../../base/common/lifecycle.js';
import * as platform from '../../registry/common/platform.js';
import { Emitter } from '../../../base/common/event.js';
export var IThemeService = createDecorator('themeService');
export function themeColorFromId(id) {
  return {
    id: id
  };
}
export var ThemeIcon;

(function (ThemeIcon) {
  function isThemeIcon(obj) {
    return obj && typeof obj === 'object' && typeof obj.id === 'string';
  }

  ThemeIcon.isThemeIcon = isThemeIcon;
  var _regexFromString = /^\$\(([a-z.]+\/)?([a-z-~]+)\)$/i;

  function fromString(str) {
    var match = _regexFromString.exec(str);

    if (!match) {
      return undefined;
    }

    var _match = _slicedToArray(match, 3),
        owner = _match[1],
        name = _match[2];

    if (!owner) {
      owner = "codicon/";
    }

    return {
      id: owner + name
    };
  }

  ThemeIcon.fromString = fromString;
  var _regexAsClassName = /^(codicon\/)?([a-z-]+)(~[a-z]+)?$/i;

  function asClassName(icon) {
    // todo@martin,joh -> this should go into the ThemeService
    var match = _regexAsClassName.exec(icon.id);

    if (!match) {
      return undefined;
    }

    var _match2 = _slicedToArray(match, 4),
        name = _match2[2],
        modifier = _match2[3];

    var className = "codicon codicon-".concat(name);

    if (modifier) {
      className += " ".concat(modifier.substr(1));
    }

    return className;
  }

  ThemeIcon.asClassName = asClassName;
})(ThemeIcon || (ThemeIcon = {})); // base themes


export var DARK = 'dark';
export var HIGH_CONTRAST = 'hc';
export function getThemeTypeSelector(type) {
  switch (type) {
    case DARK:
      return 'vs-dark';

    case HIGH_CONTRAST:
      return 'hc-black';

    default:
      return 'vs';
  }
} // static theming participant

export var Extensions = {
  ThemingContribution: 'base.contributions.theming'
};

var ThemingRegistry = /*#__PURE__*/function () {
  function ThemingRegistry() {
    _classCallCheck(this, ThemingRegistry);

    this.themingParticipants = [];
    this.themingParticipants = [];
    this.onThemingParticipantAddedEmitter = new Emitter();
  }

  _createClass(ThemingRegistry, [{
    key: "onColorThemeChange",
    value: function onColorThemeChange(participant) {
      var _this = this;

      this.themingParticipants.push(participant);
      this.onThemingParticipantAddedEmitter.fire(participant);
      return toDisposable(function () {
        var idx = _this.themingParticipants.indexOf(participant);

        _this.themingParticipants.splice(idx, 1);
      });
    }
  }, {
    key: "getThemingParticipants",
    value: function getThemingParticipants() {
      return this.themingParticipants;
    }
  }]);

  return ThemingRegistry;
}();

var themingRegistry = new ThemingRegistry();
platform.Registry.add(Extensions.ThemingContribution, themingRegistry);
export function registerThemingParticipant(participant) {
  return themingRegistry.onColorThemeChange(participant);
}
/**
 * Utility base class for all themable components.
 */

export var Themable = /*#__PURE__*/function (_Disposable) {
  _inherits(Themable, _Disposable);

  var _super = _createSuper(Themable);

  function Themable(themeService) {
    var _this2;

    _classCallCheck(this, Themable);

    _this2 = _super.call(this);
    _this2.themeService = themeService;
    _this2.theme = themeService.getColorTheme(); // Hook up to theme changes

    _this2._register(_this2.themeService.onDidColorThemeChange(function (theme) {
      return _this2.onThemeChange(theme);
    }));

    return _this2;
  }

  _createClass(Themable, [{
    key: "onThemeChange",
    value: function onThemeChange(theme) {
      this.theme = theme;
      this.updateStyles();
    }
  }, {
    key: "updateStyles",
    value: function updateStyles() {// Subclasses to override
    }
  }]);

  return Themable;
}(Disposable);